import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { changePassword } from '../repository/authRepository';

const ChangePassword: React.FC = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState<string | null>(null);
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setMessage(null);

        if (newPassword !== confirmPassword) {
            setMessage('New passwords do not match');
            setIsError(true);
            return;
        }

        if (newPassword.length < 8) {
            setMessage('New password must be at least 8 characters');
            setIsError(true);
            return;
        }

        setLoading(true);

        const result = await changePassword({
            current_password: currentPassword,
            new_password: newPassword,
            confirm_password: confirmPassword,
        });

        if ('error' in result) {
            setMessage(result.error);
            setIsError(true);
        } else {
            setMessage('Password changed successfully.');
            setIsError(false);
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        }

        setLoading(false);
    };

    return (
        <div className="auth-container">
            <h2>Change Password</h2>
            <form onSubmit={handleSubmit} className="auth-form">
                {message && (
                    <div className={isError ? 'error-message' : 'success-message'}>
                        {message}
                    </div>
                )}
                <div className="form-group">
                    <label htmlFor="currentPassword">Current Password</label>
                    <input
                        type="password"
                        id="currentPassword"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                        disabled={loading}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="newPassword">New Password</label>
                    <input
                        type="password"
                        id="newPassword"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        minLength={8}
                        disabled={loading}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="confirmPassword">Confirm New Password</label>
                    <input
                        type="password"
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        minLength={8}
                        disabled={loading}
                    />
                </div>
                <button type="submit" className="btn-primary" disabled={loading}>
                    {loading ? 'Changing...' : 'Change Password'}
                </button>
            </form>
            <p className="auth-link">
                <Link to="/">Back to dashboard</Link>
            </p>
        </div>
    );
};

export default ChangePassword;
